import React, { useLayoutEffect, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import { connect } from 'react-redux';
import Header from 'parts/Header';
import PageDetailTitle from 'parts/PageDetailTitle';
import FeaturedImage from 'parts/FeaturedImage';
import PageDetailDescription from 'parts/PageDetailDescription';
import BookingForm from 'parts/BookingForm';
import Testimony from 'parts/Testimony';
import Footer from 'parts/Footer';

import { checkoutBooking } from 'store/actions/checkout';
import { fetchPage } from 'store/actions/page';

function DetailsPage(props) {
    const { id } = useParams();
    const { page, fetchPage, checkoutBooking } = props;
    const [bookingItems, setBookingItems] = useState([]);


    useLayoutEffect(() => {
        document.title = `Green Hill Resort | Details`;
        window.scrollTo(0, 0);

        if (!page[id]) {
            fetchPage(`/item/${id}`, id);
        }
        if (!page.booking) {
            fetchPage(`/booking-event`, 'booking');
        }
        if (!page.testimonials) {
            fetchPage(`/testimonials`, 'testimonials');
        }

    }, [id, page, fetchPage]);

    useEffect(() => {
        if (page.booking && Array.isArray(page.booking.data)) {
            const filteredBookings = page.booking.data.filter(item => item.itemId === id);
            setBookingItems(filteredBookings);
        }
    }, [page.booking, id]);

    if (!page[id] || !page.testimonials) return null;

    const breadcrumb = [
        { pageTitle: "Home", pageHref: "/" },
        { pageTitle: "House Details", pageHref: "" }
    ];

    return (
        <>
            <Header {...props} />
            <PageDetailTitle
                breadcrumb={breadcrumb}
                data={page[id].data[0]}
            />
            <FeaturedImage data={page[id].data[0].imageId} />

            <section
            className="container my-5"
            style={{ position: "relative", zIndex: 5 }}
            >
            <div className="row gy-4">
                {/* Kolom Deskripsi */}
                <div className="col-12 col-md-7 pe-md-5">
                <Fade bottom delay={300}>
                    <PageDetailDescription data={page[id].data[0]} />
                </Fade>
                </div>

                {/* Kolom Booking Form */}
                <div className="col-12 col-md-5">
                <Fade bottom delay={300}>
                    <div className="d-flex justify-content-center">
                    <div className="w-100" style={{ maxWidth: "450px" }}>
                        <BookingForm
                        itemDetails={page[id].data[0]}
                        bookingItems={bookingItems}
                        startBooking={checkoutBooking}
                        />
                    </div>
                    </div>
                </Fade>
                </div>
            </div>
            </section>

            {/* <section className="container" style={{ position: 'relative', zIndex: 1 }}>
                <Activities data={page[id].data[0].activityId} />
            </section> */}

            <Testimony data={page.testimonials.testimonial} />
            <Footer />
        </>
    );
}

const mapStateToProps = (state) => ({
    page: state.page,
});

const mapDispatchToProps = {
    checkoutBooking,
    fetchPage
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPage);